import { useState } from "react"
import { GridColDef } from "@mui/x-data-grid"
import { useTranslation } from "react-i18next"

import Table from "@/components/table/Table"
import BasicButton from "@/components/button/BasicButton"
import Pagination from "@/components/table/Pagination"
import RemoveConfirmDialog from "@/app/settings/analysis-groups/sessions/RemoveConfirmDialog"
import { SessionType } from "@/types/session"
import { PAGE_SIZE } from "@/constants/pagination"

import "./sessionType.scss"
import IconButton from "@/components/button/IconButton"

export default function SessionTypeTable({
  data,
  selectedIdfSessionType,
  setSelectedIdfSessionType,
  setOpenEditDialog,
}: {
  data: SessionType[]
  selectedIdfSessionType: number | null
  setSelectedIdfSessionType: (idfSessionType: number | null) => void
  setOpenEditDialog: (open: boolean) => void
}) {
  const { t } = useTranslation()
  const [removeDialogOpen, setRemoveDialogOpen] = useState(false)
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: PAGE_SIZE,
  })

  const columns: GridColDef[] = [
    {
      field: "name",
      renderHeader: () => t("name"),
      flex: 0.5,
      sortable: false,
      renderCell: (params) => (
        <div className="SessionTypeNameCell">
          <span>{params.row.name}</span>
          <IconButton
            type="ghost"
            icon="pencil"
            size="xxs"
            onClick={() => {
              setSelectedIdfSessionType(params.row.idfSessionType)
              setOpenEditDialog(true)
            }}
          />
        </div>
      ),
    },
    {
      field: "occurrence",
      renderHeader: () => t("occurrences"),
      flex: 0.2,
      sortable: false,
    },
    {
      field: "idfSessionType",
      headerName: " ",
      renderCell: (params) => (
        <div className="SessionTypeTableBtnCont">
          <BasicButton
            type="danger-outlined"
            size="sm"
            onClick={() => {
              setSelectedIdfSessionType(params.row.idfSessionType)
              setRemoveDialogOpen(true)
            }}
            disabled={!!params.row.occurrence || params.row.length < 2}>
            <p>{t("button.remove")}</p>
          </BasicButton>
        </div>
      ),
      flex: 0.3,
      sortable: false,
    },
  ]

  return (
    <>
      <Table
        className="SessionTypeTableCont"
        columns={columns}
        rows={data}
        getRowId={(row) => row.idfSessionType}
        disableColumnResize
        rowHeight={58}
        initialState={{
          sorting: {
            sortModel: [
              {
                field: "idfSessionType", // 생성 기준 오래된 순 정렬
                sort: "asc",
              },
            ],
          },
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        rowSelection={false}
        pagination
        paginationMode="client"
        paginationModel={paginationModel}
        onPaginationModelChange={(model) => setPaginationModel(model)}
        slots={{
          pagination: Pagination,
        }}
        slotProps={{
          cell: {
            title: "",
          },
        }}
      />

      <RemoveConfirmDialog
        removeDialogOpen={removeDialogOpen}
        setRemoveDialogOpen={setRemoveDialogOpen}
        selectedIdfSessionType={selectedIdfSessionType}
        setSelectedIdfSessionType={setSelectedIdfSessionType}
      />
    </>
  )
}
